import Service, { service } from '@ember/service';
import { tracked } from '@glimmer/tracking';
import { dropTask } from 'ember-concurrency';

// TODO: HVT-7537 After HVS reaches EOL, remove vault-secrets service
export default class VaultSecretsService extends Service {
  @service api;
  @service userContext;
  @service abilities;

  @tracked secretsApps = [];

  get hasSecretsApps() {
    return this.secretsApps?.length > 0;
  }

  fetchTask = dropTask(async () => {
    const { organization, project } = this.userContext;

    if (!project?.id) {
      return this.secretsApps;
    }

    try {
      // TODO: HVT-7537 After HVS reaches EOL, remove query for secretsApp
      const secretsApps = await this.api.secrets.listApps(
        organization?.id,
        project?.id
      );

      this.secretsApps = secretsApps?.apps || [];
    } catch {
      // don't fetch resources if it fails
    }
    return this.secretsApps;
  });

  fetch() {
    return this.fetchTask.perform();
  }
}
